export default function getLastPageVisitedByScreenIdList({
  screenIdHistory,
  pathHistory,
  screenIdList,
}) {
  for (let i = 0; i < screenIdHistory.length; i += 1) {
    const screenId = screenIdHistory[i];
    if (screenIdList.includes(screenId) && pathHistory[i]) {
      return {
        screenId: screenId,
        path: pathHistory[i],
      };
    }
  }

  return null;
}
